import {
	Grid,
	GridItem,
} from '@chakra-ui/react';
import type { GridItemProps, GridProps, JsxStyleProps } from '@chakra-ui/react';

type FeatureShowcaseTemplateProps = {
	isReversed?:      boolean;
	leftContent:      React.ReactNode;
	rightContent:     React.ReactNode;
	gap?:             JsxStyleProps['gap'];
	templateColumns?: JsxStyleProps['gridTemplateColumns'];
	_grid?:           GridProps;
	_leftGridItem?:   GridItemProps;
	_rightGridItem?:  GridItemProps;
};

// eslint-disable-next-line complexity
const FeatureShowcaseTemplate = ({
	isReversed = false,
	leftContent,
	rightContent,
	gap = 24,
	templateColumns = 'repeat(auto-fit, minmax(450px, 1fr))',
	_grid,
	_leftGridItem,
	_rightGridItem,
}: FeatureShowcaseTemplateProps) => {
	const FIRST_COLUMN = 1;
	const SECOND_COLUMN = 2;

	return (
		<Grid
			alignItems={'center'}
			gap={gap}
			templateColumns={templateColumns}
			{..._grid}
		>
			<GridItem
				order={{
					base: 1,
					lg:   isReversed ? SECOND_COLUMN : FIRST_COLUMN,
				}}
				{..._leftGridItem}
			>
				{leftContent}
			</GridItem>
			<GridItem
				order={{
					base: 2,
					lg:   isReversed ? FIRST_COLUMN : SECOND_COLUMN,
				}}
				{..._rightGridItem}
			>
				{rightContent}
			</GridItem>
		</Grid>
	);
};

export default FeatureShowcaseTemplate;